module.exports = __webpack_public_path__ + "static/media/quiz-hero-1-mobile.c46bd90b.jpg";